/**
 * 🌍 Configuration i18n - Multi-langues
 * 
 * Langues supportées :
 * - FR (Français) - Défaut
 * - EN (English)
 * - ES (Español)
 * - IT (Italiano)
 * - DE (Deutsch)
 * - NL (Nederlands)
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importer les traductions
import fr from './locales/fr.json';
import en from './locales/en.json';
import es from './locales/es.json';
import it from './locales/it.json';
import de from './locales/de.json';
import nl from './locales/nl.json';

// 🌍 Liste des langues supportées
export const SUPPORTED_LANGUAGES = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
];

// Ressources de traduction
const resources = {
  fr: { translation: fr },
  en: { translation: en },
  es: { translation: es },
  it: { translation: it },
  de: { translation: de },
  nl: { translation: nl },
};

i18n
  // Détecter la langue du navigateur
  .use(LanguageDetector)
  // Passer i18n à react-i18next
  .use(initReactI18next)
  // Initialiser i18next
  .init({
    resources,
    fallbackLng: 'fr', // Français par défaut
    debug: false, // Mettre à true pour debug
    
    interpolation: {
      escapeValue: false, // React échappe déjà les valeurs
    },
    
    detection: {
      // Ordre de détection de la langue
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Clé localStorage pour sauvegarder la préférence
      lookupLocalStorage: 'lpe_language',
      // Cache la langue détectée dans localStorage
      caches: ['localStorage'],
    },
    
    react: {
      useSuspense: true,
    },
  });

export default i18n;
